<ub-card [variant]="'success'" [rounded]="true" [dividers]="false">
  <h3 title>{{ role.title }}</h3>
  @if (role.doc.translationInfo || role.description) {
    <div content>
      @if (role.description) {
        {{ role.description }}
      }
      @if (role.doc.translationInfo) {
        @if (role.description) {
          <br>
          }
          <eas-translation-info-list [translationInfo]="role.doc.translationInfo">
          </eas-translation-info-list>
        }
      </div>
    }
    <div actions>
      <eas-buttons-menu [buttons]="buttons"></eas-buttons-menu>
    </div>
  </ub-card>
